import { Autocomplete, AutocompleteChangeDetails, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { AgentSelectorSelector, setAgentSelectorSearchResults } from './reducers/AgentSelectorReducer';
import AgentApi from '../Agent/api/AgentApi';
import AgentModel from '../Agent/models/AgentModel';

interface AgentSelectorProps {
    selectedAgentId: string | null,
    currentAgentName?: string,
    label: string,
    useFocusMode?: boolean,
    focusValue?: number,
    className?: string,
    disabled?: boolean,
    error?: boolean,
    onChange?: (value: AgentModel | null) => void,
}


const AgentSelector: React.FunctionComponent<AgentSelectorProps> = (props) => {
    const dispatch = useDispatch();
    const AgentSelectorData = useSelector(AgentSelectorSelector);
    const textboxRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
        if (AgentSelectorData.searchResults.length > 0) {
            return;
        }

        AgentApi.GetAll()
            .then((response: BaseResponse<AgentModel[]>) => {
                if (response.success) {
                    dispatch(setAgentSelectorSearchResults(response.data))
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
    }, [])

    let getById = (agentId: string | null) => {
        if (agentId == null) {
            return null
        }
        let selectedItem = _.find(AgentSelectorData.searchResults, (item) => {
            return item.id == agentId;
        })

        return selectedItem;
    }


    useEffect(() => {
        if (props.useFocusMode === true) {
            textboxRef.current?.focus();
        }
    }, [props.focusValue])

    return (
        <>
            {
                AgentSelectorData.searchResults.length > 0 &&
                <Autocomplete
                    fullWidth
                    disabled={props.disabled}
                    className={props.className ? props.className : ""}
                    value={getById(props.selectedAgentId)}
                    options={AgentSelectorData.searchResults}
                    renderInput={(params) => <TextField {...params} label={props.label} inputRef={textboxRef} error={props.error} />}
                    getOptionLabel={(option: AgentModel) => {
                        return option.name;
                    }}
                    onChange={(event: React.SyntheticEvent, value: AgentModel | null, reason: string, details?: AutocompleteChangeDetails<AgentModel> | undefined) => {
                        if (props.onChange) {
                            props.onChange(value);
                        }
                    }}
                />
            }
        </>
    )
};

export default AgentSelector;